import { render } from "./ProposalDetail.vue?vue&type=template&id=19f4b36a&scoped=true"
import script from "./ProposalDetail.vue?vue&type=script&lang=js"
export * from "./ProposalDetail.vue?vue&type=script&lang=js"

import "./ProposalDetail.vue?vue&type=style&index=0&id=19f4b36a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f4b36a"]])

export default __exports__